import { BrowserRouter, useLocation } from "react-router-dom";
import AllRoutes from "./Pages/Routes/AllRoutes";
import ModernHeader from "./Pages/Header/ModernHeader.tsx";
import { AuthProvider } from "./contexts/AuthContext";

function HeaderWrapper() {
  const location = useLocation();

  // Add paths where you don't want the header to show
  const noHeaderPaths = [
    "/login",
    "/admin-dash",
    "/forgot-password",
    "/reset-password",
    "/unsubscribe",
  ];

  if (noHeaderPaths.includes(location.pathname)) {
    return null;
  }

  return <ModernHeader />;
}

function App() {
  return (
    <div
      className="app-container"
      style={{
        backgroundColor: "#ffffff",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
      }}
    >
      <AuthProvider>
        <BrowserRouter>
          <HeaderWrapper />
          <main className="main-content">
            <AllRoutes />
          </main>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
